import React from 'react';
import { Box, Typography } from '@mui/material';
import useStyles from './billsDashboardStyles';

/** Shown in place of a figure the API cannot answer for yet. */
const UNAVAILABLE = '—';

/**
 * The four figures across the top of the Bills page.
 *
 * Two are real: "Needs review" (from the loaded rows) and "Allowed senders" (a count the caller
 * passes from the allowed-senders list endpoint — that list is small and returned whole, so the
 * count is exact). Processed-this-month and average processed time still need aggregates that the
 * bills endpoint does not return — counting them over the loaded page would be wrong the moment a company
 * has more bills than one page holds — so those two render as "—" with the reason underneath rather
 * than a number that would be believed.
 *
 * "Needs review" is only right while every bill fits on the loaded page; it counts rows in hand, not
 * rows that exist. Worth a server-side count when the list endpoint grows one.
 *
 * allowedSendersCount is undefined while the list is loading or when there is no company context;
 * the tile shows "—" until it resolves to a number.
 */
export const BillsSummaryCards = _ref => {
  let needsReviewCount = _ref.needsReviewCount,
    allowedSendersCount = _ref.allowedSendersCount;
  const classes = useStyles();
  const cards = [{
    label: 'Needs review',
    value: String(needsReviewCount),
    hint: needsReviewCount === 0 ? 'Nothing waiting' : 'Match these to a property',
    isAvailable: true
  }, {
    label: 'Processed this month',
    value: UNAVAILABLE,
    hint: 'Needs a server-side count',
    isAvailable: false
  }, {
    label: 'Allowed senders',
    value: typeof allowedSendersCount === 'number' ? String(allowedSendersCount) : UNAVAILABLE,
    hint: 'Currently trusted',
    isAvailable: typeof allowedSendersCount === 'number'
  }, {
    label: 'Avg processed time',
    value: UNAVAILABLE,
    hint: 'Needs a server-side count',
    isAvailable: false
  }];
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.kpiRow
  }, cards.map(card => /*#__PURE__*/React.createElement(Box, {
    key: card.label,
    className: classes.kpiCard
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.kpiLabel
  }, card.label), /*#__PURE__*/React.createElement(Typography, {
    component: "p",
    className: "".concat(classes.kpiValue, " ").concat(card.isAvailable ? '' : classes.kpiValueUnavailable)
  }, card.value), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.kpiHint
  }, card.hint))));
};